import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files directly to ensure they are bundled
import translationPT from './locales/pt/translation.json';
import translationES from './locales/es/translation.json';
import translationFR from './locales/fr/translation.json';
import translationEN from './locales/en/translation.json';
import translationIT from './locales/it/translation.json';
import translationDE from './locales/de/translation.json';

// Translation resources
const resources = {
  pt: { translation: translationPT },
  es: { translation: translationES },
  fr: { translation: translationFR },
  en: { translation: translationEN },
  it: { translation: translationIT },
  de: { translation: translationDE }
};

i18n
  // Detect user language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Init i18next
  .init({
    resources,
    lng: localStorage.getItem('selectedLanguage') || 'en', // Force English if no language is stored
    fallbackLng: 'en',
    debug: false,

    supportedLngs: ['pt', 'es', 'fr', 'en', 'it', 'de'],
    load: 'languageOnly',

    detection: {
      order: ['localStorage'], // Only respect what's stored in localStorage, ignore browser settings
      caches: ['localStorage'],
      lookupLocalStorage: 'selectedLanguage'
    },

    interpolation: {
      escapeValue: false, // React already escapes
      prefix: '{',
      suffix: '}'
    },

    react: {
      useSuspense: false
    }
  });

export default i18n;